function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { callAllHandlers } from './fieldUtils';
var identityFn = function identityFn(props) {
  return props;
};
var FormRadioSetContext = /*#__PURE__*/React.createContext({
  getRadioControlProps: identityFn,
  hasRadioSetProvider: false
});
var useRadioSetContext = function useRadioSetContext() {
  return useContext(FormRadioSetContext);
};
function FormRadioSetContextProvider(_ref) {
  var children = _ref.children,
    name = _ref.name,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    onChange = _ref.onChange,
    value = _ref.value,
    defaultValue = _ref.defaultValue;
  var isControlled = !defaultValue && value !== undefined;
  var getRadioControlProps = function getRadioControlProps(radioProps) {
    return _objectSpread(_objectSpread({}, radioProps), {}, {
      name: name,
      /* istanbul ignore next */
      onBlur: radioProps.onBlur ? callAllHandlers(onBlur, radioProps.onBlur) : onBlur,
      /* istanbul ignore next */
      onFocus: radioProps.onFocus ? callAllHandlers(onFocus, radioProps.onFocus) : onFocus,
      /* istanbul ignore next */
      onChange: radioProps.onChange ? callAllHandlers(onChange, radioProps.onChange) : onChange,
      checked: isControlled ? value === radioProps.value : undefined,
      defaultChecked: isControlled ? undefined : defaultValue === radioProps.value
    });
  };
  var contextValue = {
    name: name,
    value: value,
    defaultValue: defaultValue,
    getRadioControlProps: getRadioControlProps,
    onBlur: onBlur,
    onFocus: onFocus,
    onChange: onChange,
    hasRadioSetProvider: true
  };
  return /*#__PURE__*/React.createElement(FormRadioSetContext.Provider, {
    value: contextValue
  }, children);
}
FormRadioSetContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  value: PropTypes.string,
  defaultValue: PropTypes.string
};
FormRadioSetContextProvider.defaultProps = {
  onBlur: undefined,
  onFocus: undefined,
  onChange: undefined,
  value: undefined,
  defaultValue: undefined
};
export default FormRadioSetContext;
export { useRadioSetContext, FormRadioSetContextProvider };
//# sourceMappingURL=FormRadioSetContext.js.map